"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationsApi = void 0;
const generated_1 = require("./generated");
class ConfigurationsApi {
    constructor(configuration, basePath, axios) {
        this.configurationsApi = new generated_1.ConfigurationsApi(configuration, basePath, axios);
    }
    addConfiguration(createConfigurationDto, options) {
        return this.configurationsApi.createConfiguration(createConfigurationDto, options);
    }
    deleteConfiguration(id, options) {
        return this.configurationsApi.deleteConfiguration(id, options);
    }
    getAllConfigurations(languageCode, options) {
        if (languageCode) {
            if (!options) {
                options = { params: { lang: languageCode } };
            }
            else {
                options = {
                    ...options,
                    params: options.params ? { ...options.params, lang: languageCode } : { lang: languageCode },
                };
            }
        }
        return this.configurationsApi.findAllConfigurations(options);
    }
    updateConfiguration(id, updateConfigurationDto, options) {
        return this.configurationsApi.editConfiguration(id, updateConfigurationDto, options);
    }
}
exports.ConfigurationsApi = ConfigurationsApi;
//# sourceMappingURL=configuration-api.js.map